import { Worm } from "@eai-toolkit-material-ui/icons";
import type { SvgIconTypeMap } from "@mui/material";
import { Box, CardContent, Card as MuiCard, Typography } from "@mui/material";
import type {
  OverridableComponent,
  OverrideProps,
} from "@mui/material/OverridableComponent";
import type { SxProps, Theme } from "@mui/material/styles";
import { mergeSx } from "merge-sx";
import React from "react";

const Card = (props: {
  title: string;
  sx?: SxProps<Theme>;
  children: React.ReactNode;
  footer: React.ReactNode;
  icon?:
    | React.NamedExoticComponent<
        OverrideProps<SvgIconTypeMap<{}, "svg">, "svg">
      >
    | OverridableComponent<SvgIconTypeMap<{}, "svg">>;
}) => {
  const Icon = props.icon || Worm;
  return (
    <MuiCard
      sx={mergeSx<Theme>(
        (theme) => ({
          backgroundColor: "white",
          paddingRight: theme.spacing(2),
          marginBottom: theme.spacing(2),
        }),
        props.sx,
      )}
    >
      <CardContent
        sx={(theme) => ({
          height: "100%",
          display: "grid",
          gridAutoFlow: "column",
          gap: theme.spacing(2),
          gridTemplateColumns: "auto 1fr",
        })}
      >
        <Icon color="primary" sx={{ marginTop: "5px" }} />
        <Box
          sx={{
            height: "100%",
            display: "grid",
            gridTemplateRows: "auto 1fr auto",
            gap: "6px",
          }}
        >
          <Typography variant="body1" component="h4">
            {props.title}
          </Typography>
          <Typography variant="body2" color="text.secondary" component="p">
            {props.children}
          </Typography>
          {props.footer}
        </Box>
      </CardContent>
    </MuiCard>
  );
};

export default Card;
